<script setup>
// Floating help launcher (bottom-right ?). Opens a small resource panel:
// popular guides (in the drawer), browse all, restart the product tour, contact.
import { ref } from 'vue';
import { useMesselloHelp } from 'dashboard/composables/useMesselloHelp';

const { HELP_BASE, openHelp, startTour } = useMesselloHelp();
const open = ref(false);

const POPULAR = [
  { slug: 'what-is-messello', title: 'What is Messello?' },
  { slug: 'add-website-live-chat', title: 'Add live chat to your website' },
  { slug: 'connect-whatsapp', title: 'Connect WhatsApp' },
  { slug: 'messello-ai-overview', title: 'Messello AI: what’s included' },
  { slug: 'invite-your-team', title: 'Invite your team' },
];

const pick = (slug, title) => {
  open.value = false;
  openHelp(slug, title);
};
const runTour = () => {
  open.value = false;
  startTour();
};
</script>

<template>
  <div class="mz-launcher">
    <transition name="mz-pop">
      <div v-if="open" class="mz-panel" role="dialog" aria-label="Help and guides">
        <div class="mz-panel-head">Help &amp; guides</div>
        <div class="mz-panel-sub">Popular articles</div>
        <button
          v-for="a in POPULAR"
          :key="a.slug"
          class="mz-panel-item"
          @click="pick(a.slug, a.title)"
        >
          {{ a.title }}
        </button>
        <div class="mz-panel-div" />
        <a
          class="mz-panel-item mz-panel-link"
          :href="HELP_BASE"
          target="_blank"
          rel="noopener"
          @click="open = false"
        >Browse all guides ↗</a>
        <button class="mz-panel-item" @click="runTour">↻ Restart the product tour</button>
        <a
          class="mz-panel-item mz-panel-link"
          href="mailto:hello@messello.com"
          @click="open = false"
        >Contact us</a>
      </div>
    </transition>
    <button
      class="mz-fab"
      data-messello-tour="help"
      :aria-expanded="open"
      aria-label="Help"
      @click="open = !open"
    >
      <span v-if="!open">?</span>
      <span v-else>✕</span>
    </button>
  </div>
</template>

<style scoped>
.mz-launcher {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9990;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}
.mz-fab {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 0;
  background: #3b6cf6;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 10px 26px rgba(59, 108, 246, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mz-fab:hover {
  background: #2a55d6;
}
.mz-panel {
  width: 280px;
  background: #fff;
  border: 1px solid #e6eaf1;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);
  padding: 8px;
  font-family: inherit;
}
.mz-panel-head {
  font-weight: 700;
  font-size: 15px;
  color: #0f172a;
  padding: 10px 12px 4px;
}
.mz-panel-sub {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #94a3b8;
  padding: 6px 12px 4px;
}
.mz-panel-item {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 9px 12px;
  border-radius: 9px;
  font-size: 14px;
  color: #334155;
  cursor: pointer;
  font-family: inherit;
  text-decoration: none;
}
.mz-panel-item:hover {
  background: #f2f6ff;
  color: #0f172a;
}
.mz-panel-link {
  color: #2a55d6;
  font-weight: 600;
}
.mz-panel-div {
  height: 1px;
  background: #eef1f6;
  margin: 6px 8px;
}
.mz-pop-enter-active,
.mz-pop-leave-active {
  transition: all 0.16s ease;
}
.mz-pop-enter-from,
.mz-pop-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(0.98);
}
</style>
